<template>

    <div class="kalem">
    <imagefiledialog ref="imagefiledialog"></imagefiledialog>
    <loadingcomp mesaj="Fiş" v-model="loadingStatus"></loadingcomp>




            <v-layout row wrap>

                <v-flex xs12 md12 sm12>
                    <v-layout row wrap>
                        <yetkidialog ref="yetkidialog"></yetkidialog>
                         <v-toolbar class="baslik" size="120px" dark color="info">
                            <v-toolbar-title class="baslikfont"> {{ mainTitle }}  </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <a target="_self" v-bind:href="'#/coper/saticilar/islem/id?isl=yeni&tip=14'">
                                <v-btn flat> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Insurance')}) }} </span>
                                <v-icon right dark>add_box</v-icon>
                                </v-btn>
                            </a>
                        </v-toolbar>
                     
                      
                        <div class="d-flex flex-row mb-6 bg-surface-variant">
      <v-sheet class="ma-2 pa-2"> <v-checkbox
    @change="komisyonChanged"
      v-model="komisyonGoster"
      label="Komisyon Göster"
    ></v-checkbox></v-sheet>
      <v-sheet class="ma-2 pa-2"> <v-checkbox
    @change="gosterCariChanged"
      v-model="cariGoster"
      label="Cari Hesap Göster"
    ></v-checkbox></v-sheet>
      <v-sheet class="ma-2 pa-2">  <v-checkbox
    @change="komisyonAciklamaChanged"
      v-model="komisyonAciklamaGoster"
      label="Komisyon Dahil/Hariç Açıklama Göster"
    ></v-checkbox></v-sheet>
    </div>
                     
    

                        
               
                       
    
        
                       
                        <v-flex xs12 sm12 md12>
                            <span class=" font-weight-regular grey--text title"></span>
                            <v-divider></v-divider>
                        </v-flex>

             
                        <v-flex v-if="vouchergoster>0" xs10 pa-3 sm10 md10>
                         <v-card class="pa-3">


                            <div id="printJS-form">
                                <table style="page-break-after: always;" v-for="item in voucheritems.Sayfalar"
                                    :key="item.id" width="100%">
                                    <thead class="print">
                                        <tr>
                                            <td colspan="8">
                                            <table width="100%">
                                                <tr
                                                colspan="8"
                                                align="center"
                                                style="
                                                    padding-top: 20px;
                                                    padding-bottom: 20px;
                                                "
                                                >
                                                <td
                                                    align="left"
                                                    style="
                                                    width: 100%;
                                                    vertical-align: top;
                                                    padding-top: 10px;
                                                    padding-bottom: 10px;
                                                    "
                                                    id="imgUst"
                                                ></td>
                                                </tr>
                                            </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td bgcolor="grey" colspan="10" align=center
                                                style="padding-top:10px;padding-bottom:10px;">
                                                <span class=" white--text title">{{ mainTitle }}</span>
                                            </td>
                                        </tr>
                                        <br />
                                        <tr align=left>
                                            <td align="left" style="width:35%">
                                                <span class=".subtitle-2 font-weight-bold"> {{item.Satici.Isim}}</span>
                                            </td>

                                            <td style="width:60%">

                                            </td>

                                            <td style="width:35%">
                                                {{$t('Date')}}:
                                            </td>

                                            <td style="width:15%" align=left>
                                                {{getDateNow() | dateformat}}
                                            </td>

                                        </tr>

                                        <tr>
                                            <td>
                                                {{item.Satici.Yer}} &nbsp;
                                                {{item.Satici.Ulke}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                {{$t('Hour')}} :
                                            </td>
                                            <td>
                                                {{getdatetimenow()}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Tel: {{item.Satici.Tel1}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                 {{ $t('Bill-No') }} :
                                            </td>
                                            <td>
                                                {{item.RaporNo}}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                Tel2: {{item.Satici.Tel2}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>

                                            </td>
                                            <td>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td style="padding-top:30px;" colspan="10">
                                                <table width="100%">
                                                    <tr bgcolor="grey" colspan="10" align=center>
                                                        <td style="margin-top:20px;width:5%;">
                                                            <span class=" white--text subheading">  {{ $t('Room-No') }} </span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> Pnr No</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> K.Tip</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> Kont.</span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class=" white--text subheading"> {{ $t('Name') }} </span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" white--text subheading">  {{ $t('Entry-Departure-Date') }} </span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('night') }}  </span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> Pax</span>
                                                        </td>

                                                        <td style="width:10%">
                                                            <span class=" white--text subheading"> Pansiyon</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading">{{$t('Room-Type')}} </span>
                                                        </td>



                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <table v-for="itemoda in item.Odalar" :key="itemoda.Sira" width="100%">

                                                    <tr align=center v-for="itemkisi in itemoda.Kisiler"
                                                        :key="itemkisi.adsoyad"
                                                        style="padding-top:10px;padding-bottom:10px;">


                                                        <td style="width:5%">
                                                            <span class="body-1">
                                                                {{itemoda.Sira}}
                                                            </span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class="  body-1"> {{pnr}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{KisiTipToStr(itemkisi.kisiTip)}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{itemoda.Kalem.kalemOtel.kontenjan | kont}}</span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class="body-1"> {{itemkisi.adSoyad}}</span>
                                                            <span
                                                                class="caption red--text"><br>({{odeyenTarafGetir(itemoda.Kalem.odeyenTaraf)}})</span>

                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="body-1">
                                                                {{itemoda.Kalem.donem1 | dateformat}}/{{itemoda.Kalem.donem2| dateformat}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{gunhesapla(itemoda.Kalem)}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{itemkisi.Pax}}</span>
                                                        </td>

                                                        <td style="width:10%">
                                                            <span class="  body-1">
                                                                {{PansiyonTipToStr(itemoda.Kalem.kalemOtel.pansiyon)}}</span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{itemoda.Kalem.kalemOtel.odaTipi.kod}}
                                                            </span>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td colspan="10">
                                                            <v-divider></v-divider>
                                                        </td>
                                                    </tr>
                                                </table>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <table align="left" width="100%">
                                                    <tr align=left style="padding-top:15px;padding-bottom:15px;">
                                                      <td style="width:20%" v-if="cariGoster==true">
                                                            <span class="  subheading"> Cari Hesap :
                                                                {{item.CariHesap.isim}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="  subheading"> Toplam Pax :
                                                                {{item.ToplamPax}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" subheading"> Toplam Oda :
                                                                {{odaSayisiGetir(item)}}</span>
                                                        </td>
                                                        <td>
                                                            <span class="  subheading">Oda Sayıları </span>
                                                        </td>
                                                        <td v-for="itemodasayi in item.OdaToplamlari"
                                                            :key="itemodasayi.id">
                                                            <span class=" subheading"> {{itemodasayi.OdaKodu}} :
                                                                {{itemodasayi.Adet}} </span>
                                                        </td>
                                                    </tr>
                                                    <tr align=left style="padding-top:20px;padding-bottom:20px;">

                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                        <br />
                                        <tr style="padding-top:30px;padding-bottom:30px;">
                                            <td colspan="10">
                                                <table border="1" style="border-collapse: collapse;" width="100%">


                                                    <tr align="center" style="padding-top:30px;padding-bottom:30px;">
                                                        <td rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading"> Pns.</span>
                                                        </td>
                                                        <td rowspan="2" style="width:20%">
                                                            <span class=" black--text subheading"> {{ $t('Room-Type') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:5%">
                                                            <span class=" black--text subheading"> {{ $t('Location') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:5%">
                                                            <span class=" black--text subheading"> Pax</span>
                                                        </td>
                                                        <td v-if="komisyonGoster == true" rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading"> {{ $t('Commission') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading">  {{ $t('Unit-Price') }} </span>
                                                        </td>
                                                        <td v-if="komisyonAciklamaGoster==true" colspan="4" style="width:40%">
                                                            <span class=" black--text subheading"> {{ $t('Included-in-Commission') }}  /
                                                                {{ $t('Excluding') }}</span>
                                                        </td>
                                                    </tr>

                                                    <tr align=center style="padding-top:20px;padding-bottom:20px;">


                                                        <td style="width:10%">
                                                            <span class=" black--text subheading"> Kdv</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Breakfast') }}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Lunch') }} </span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Dinner') }} </span>
                                                        </td>
                                                    </tr>

                                                    <tr v-for="odeme in item.Fiyatlar" :key="odeme.id" align=center
                                                        style="padding-top:20px;padding-bottom:20px;">
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{PansiyonTipToStr(odeme.Pansiyon)}}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class="  body-1"> {{odeme.OdaTipi.kod}}

                                                            </span><br> <span
                                                                class="caption red--text">({{odeyenTarafGetir(odeme.OdeyenTaraf)}})</span>
                                                        </td>
                                                        <td>{{odeme.Konum}}</td>
                                                        <td>{{odeme.Pax}}</td>
                                                        <td v-if="komisyonGoster == true">{{odeme.Komisyon | moneyformat}} {{odeme.KomisyonPara}}</td>
                                                        <td>{{odeme.BirimFiyat | moneyformat}} {{odeme.FiyatPara}}</td>
                                                        <td>{{odeme.KDH_KDV | truefalse}} </td>
                                                        <td>{{odeme.KDH_Kahvalti | truefalse}} </td>
                                                        <td>{{odeme.KDH_OglenYemegi | truefalse}} </td>
                                                        <td>{{odeme.KDH_AksamYemegi | truefalse}} </td>
                                                    </tr>

                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="11">
                                                {{Aciklamalar.Not}}
                                            </td>
                                        </tr>


                                        <br />

                                        <br />
                                        <br />
                                        <br />
                                        <br />

                                        <tr style="padding-top:20px;margin-top:10px;">

                                            <td colspan="4">
                                                <table width="100%">
                                                    <tr>
                                                        <td style="padding-top:60px;margin-top:60px;">
                                                            {{voucheritems.SirketBilgileri.SirketIsmi}}
                                                        </td>
                                                        <td>
                                                            {{$t('Person-Offering-Booking')}}
                                                        </td>
                                                        <td>
                                                            {{  $t('Approval')}}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres1}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres2}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketTelefon}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketFaks}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{$t('Email_label')}}
                                                        </td>
                                                    </tr>

                                                </table>
                                            <td>

                                            </td>

                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <span class="grey--text caption"> {{getDateNow() | dateformat}}
                                                    {{getdatetimenow()}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                        <td colspan="10">
                                        <div id="imgAlt"></div>
                                        </td>
                                    </tr>

                                    </thead>

                                </table>
                            </div>

                         </v-card>


                        </v-flex>

                        <v-flex pa-3 xs2 sm2 md2>
                            <v-card class="pa-3">
                            <v-layout justify-center row wrap>
                                <!-- <v-btn @click="voucheryazdir()" color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn> -->
                        <v-flex xs12 sm12 md12>
                        <v-btn
                          block
                          color="info"
                          outline
                          @click="LogoKaydet('Üst Logo Seçiniz', 'UstLogo')"
                        >
                          {{ $t('Upper-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-btn
                          block
                          color="info"
                          @click="LogoKaydet('Alt Logo Seçiniz', 'AltLogo')"
                          outline
                        >
                          {{ $t('Lower-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>
                        <v-flex xs12 sm12 md12>
                                <v-btn @click="denemeyazdir('printJS-form')" block color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn>
                        </v-flex>
                            </v-layout>
                          </v-card>

                        </v-flex>


                    </v-layout>

                </v-flex>



            </v-layout>
        </v-card>
    </div>
</template>

<script>
import rez from "../../rezervasyon";
import printJS from "print-js";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import tarihcomp from "../../../customcomp/tarihim";
import parainput from "../../../customcomp/parainput";
import yuzdeinput from "../../../customcomp/yuzdeinput";
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "../../tools";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  components: {
    kur,
    genelarama,
    genelaramakod,
    tarihcomp,
    geneltipara,
    parainput,
    yuzdeinput,
    yetkidialog,
    imagefiledialog,
    loadingcomp,
  },
  watch: {
    tumunusec(valsec) {
      if (valsec == true) {
        this.secilenkayitlar = this.val.Kisiler;
      } else {
        this.secilenkayitlar = [];
      }
    },
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      komisyonAciklamaGoster:true,
      cariGoster:true,
      komisyonGoster:false,
      loadingStatus: false,
      UstLogoUrl: null,
      AltLogoUrl: null,
      Aciklamalar: {
        Aciklama1: null,
        Aciklama2: null,
        Not: null,
      },
      pnr: null,
      vouchergoster: false,
      voucheritems: [],
      aractipitems: [],
      menu2: false,
      menu1: false,
      menualissati: false,
      menuteslimsati: false,
      menumusteslimsati: false,
      ucusnoitems: [],
      rehberdilitems: [],
      transfertipitems: [
        {
          text: this.$t('None'),
          value: "Yok",
        },
        {
          text: this.$t('Golf-course-tasks'),
          value: "Golf Sahası Yapacak",
        },
        {
          text: this.$t('Agency-tasks'),
          value: "Acenta Yapacak",
        },
      ],

      vizetipitems: rez.VizeTipi(),
      vizedurumuitems: rez.VizeDurumu(),
      vizegiristipiitems: rez.VizeGirisTipi(),
      mainTitle: null,
      tumunusec: false,
      secilenkayitlar: [],
      dialogShow: false,
      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,

      tabmodel: "tab-genel",

      kisiSira: [],
      headers: [
        {
          text: "Isim",
          align: "left",
          value: "adSoyad",
          sortable: false,
        },
      ],
      menuItems: [
        {
          title: this.$t('Find-Price')
        },
        {
          title: this.$t('Calculate-Price')
        },
      ],
      Pansiyon: [
        {
          kod: 0, //"OB",
          aciklama: "Only Bed",
        },
        {
          kod: 1, //"BB",
          aciklama: "Bed & Breakfast",
        },
        {
          kod: 2, //"HB",
          aciklama: "Half Board",
        },
        {
          kod: 3, //"FB",
          aciklama: "Full Board",
        },
        {
          kod: 4, //"FF",
          aciklama: "FF",
        },
        {
          kod: 5, //"FC",
          aciklama: "FC",
        },
        {
          kod: 6, //"AI",
          aciklama: "All Inclusive",
        },
        {
          kod: 7, //"UAI",
          aciklama: "Ultra All Inclusive",
        },
      ],
    };
  },

  created() {},
  methods: {
    PansiyonTipToStr(tip) {
      if (tip == null) {
        tip = 0;
      }

      var varmi = this.Pansiyon.filter(function (el) {
        return el.kod == tip;
      });
      if (varmi.length != 0) {
        return varmi[0].aciklama;
      } else {
        return null;
      }
    },
    getImages() {
      var params = {
        FileCode: "UstLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.UstLogoUrl =
              "data:image/jpeg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.UstLogoUrl =
              "data:image/jpg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.UstLogoUrl =
              "data:image/png;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          }
        }
      });

      var params1 = {
        FileCode: "AltLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params1).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.AltLogoUrl =
              "data:image/jpeg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.AltLogoUrl =
              "data:image/jpg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.AltLogoUrl =
              "data:image/png;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          }
        }
      });
    },
    addUpImage(imageUrl) {
      if (this.UstLogoUrl != null) {
        var newImageUst = document.createElement("img");
        newImageUst.src = imageUrl;
        newImageUst.style = "width:1000px;height:200px;";
        document.getElementById("imgUst").innerHTML = "";
        document.getElementById("imgUst").appendChild(newImageUst);
      }
    },
    addDownImage(imageUrl) {
      if (this.AltLogoUrl != null) {
        var newImageAlt = document.createElement("img");
        newImageAlt.src = imageUrl;
        newImageAlt.style = "width:1000px;height:200px;";
        document.getElementById("imgAlt").innerHTML = "";
        document.getElementById("imgAlt").appendChild(newImageAlt);
      }
    },
    LogoKaydet(Title, FileCode) {
      this.$refs.imagefiledialog.open(Title, FileCode).then((confirm) => {
        if (confirm !== "") {
          this.otelrezfisYazdir(this.$route.query.PNR_No);
        }
      });
    },
    odaSayisiGetir(val) {
      var sum = val.OdaToplamlari.reduce(function (a, b) {
        return a + b.Adet;
      }, 0);
      return sum;
    },
    odeyenTarafGetir(val) {
      return rez.OdeyenTarafGetir(val);
    },
    getdatetimenow() {
      var timenow = helpers.getTimeNow();

      return String(timenow);
    },

    gunhesapla(val) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(val.donem1);
      const secondDate = new Date(val.donem2);

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      return diffDays;
    },

    denemeyazdir(divName) {
      // var mywindow = window.open("", "PRINT", "height=500,width=700");

      // mywindow.document.write("</head><body >");
      // mywindow.document.write(document.getElementById(divName).innerHTML);
      // mywindow.document.write("</body></html>");

      // mywindow.document.close(); // necessary for IE >= 10
      // mywindow.focus(); // necessary for IE >= 10*/

      // mywindow.print();
      // mywindow.close();

      // return true;
            printJS({
        printable: "printJS-form",
        type: "html"
      });
    },
    voucheryazdir() {
      var prm = {
        printable: this.someJSONdata,
        properties: ["name", "email", "phone"],
        type: "json",
      };

      //'printJS-form', 'html'
      printJS("printJS-form", "html");
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    otelrezfisYazdir(val) {
      this.loadingStatus = true;

      var params = {
        PNR_No: val,
      };
      tool.http_post(this, "OtelRezFis", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.voucheritems = response.body.data;
            this.Aciklamalar = response.body.data.Aciklamalar;
            this.sleep(5000).then(() => {
              this.getImages();
              this.loadingStatus = false;
            });
            this.vouchergoster = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.vouchergoster = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.vouchergoster = false;
        }
      );
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    getDateNow() {
      return helpers.getDateNow();
    },
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    },
  },
  komisyonChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  gosterCariChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  komisyonAciklamaChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.pnr = this.$route.query.PNR_No;
      var rezType = this.$route.query.rezType;
      switch (rezType) {
        case "1":
          this.mainTitle = "REZERVASYON FİŞİ";
          break;
        case "2":
          this.mainTitle = "REZERVASYON İPTAL FİŞİ";
          break;
        case "3":
          this.mainTitle = "REZERVASYON DEĞİŞİKLİK FİŞİ";
          break;
        default:
          break;
      }

      this.otelrezfisYazdir(this.$route.query.PNR_No);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },

  filters: {
    truefalse: function (t) {
      if (t == true) {
        return "Hariç";
      } else {
        return "Dahil";
      }
    },
    kont: function (t) {
      if (t == true) {
        return "Evet";
      } else {
        return "Hayır";
      }
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  moneyformat: function (m) {
    return helpers.moneyformat(m);
  },

  bakiyekontrol: function (m) {
    return helpers.bakiyekontrol(m);
  },
};
</script>
<style>
table {
  border-collapse: collapse;
}
</style>